import toPromise from 'lib/to-promise';
import Backbone from 'backbone';
import EF from 'ef/ef';

const PollService = function () {
  this.renderPoll = function (blockView) {
    if (EF.options.local) {
      const options = { parse: true };
      blockView.poll.fetch(options).done(() => {
        setProperties(blockView);
        blockView.render();
      });
    } else {
      blockView.render();
    }
  };

  this.getUrl = function (model) {
    const enrollmentId = EF.enrollment.get('id');
    return EF.url(`/sdk/enrollments/${enrollmentId}/poll.json`);
  };

  this.parse = function (response) {
    return response;
  };

  this.save = function (model, options) {
    if (EF.options.local) {
      return new Promise(resolve => {
        const totals = getTotals(model);
        model.set('totals', totals);
        if (options && options.success) {
          options.success({ totals });
        }
        resolve({ totals });
      });
    } else {
      return toPromise(Backbone.Model.prototype.save.apply(model));
    }
  };

  const getTotals = function (model) {
    return model.get('answers').map(a => {
      return {
        id: a.id,
        count: Math.floor(Math.random() * (500 - 1) + 1),
      };
    });
  };

  const setProperties = function (blockView) {
    blockView.poll.property('text', () => {
      blockView.model.set('text', blockView.poll.get('text'));
    });
    blockView.poll.property('id', () => {
      blockView.model.set('id', blockView.poll.get('id'));
    });
    blockView.poll.property('answers', () => {
      blockView.model.set('answers', blockView.poll.get('answers'));
    });
  };
};

export default new PollService();
